import { get } from '..';

const getMyTickets = (buildingId: string) => get(`assets/user-tickets?buildingId=${buildingId}`);

export default getMyTickets;
